import { Dialog } from "@/design-system/components/Dialog/Dialog";
import { EditProfileForm } from "@/account/components/EditProfileForm/EditProfileForm";

export interface EditProfileModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function EditProfileModal({
  open,
  onOpenChange,
}: EditProfileModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title="Edit profile">
      <EditProfileForm
        onSaved={() => onOpenChange(false)}
        onCancel={() => onOpenChange(false)}
      />
    </Dialog>
  );
}
